import * as yup from "yup";
import {
    nameRule,
    passwordRule,
} from "../commonRules";

export const SetupRecruiterAccountSchema = yup.object().shape({
    first_name: nameRule("First Name", { required: true }),
    last_name: nameRule("Last Name", { required: true }),
    password: passwordRule("Password", { required: true }),
    confirm_password: passwordRule("Confirm Password", { required: true }),

});

export default SetupRecruiterAccountSchema;
